import { useMemo } from 'react';

import { getInfo, keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters'
import column, { defaultColumn, deleteAction, editAction, defaultActionsColumn, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import ContentTypeFormatter from './ContentTypeFormatter'
import FileLink from './FileLink'
import MultipleDomainsFormatter from './MultipleDomainsFormatter'

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('path', {
      header: 'Slug',
      cell: info => <NameAndCreateDateFormatter info={info} />,
    }),
    column.accessor('content_type', {
      header: 'Content Type',
      cell: info => <ContentTypeFormatter info={info} />,
      enableTruncateTooltip: true,
    }),
    defaultActiveColumn(),
    defaultColumn('meta', 'Multiple Domains', multipleDomainsToggleFormatter, { enableColumnResize: false }),
    defaultActionsColumn(editAction, deleteAction, fileLinkAction),
  ], [])
}

function fileLinkAction(info) {
  const { row } = getInfo(info)

  if (row.meta?.files) {
    return null
  }

  return <FileLink key={keyOf(info, 'file-link')} info={info} />
}

function multipleDomainsToggleFormatter(info) {
  return <MultipleDomainsFormatter key={keyOf(info)} info={info} />
}
